import { Skeleton, Stack, Typography } from '@mui/material'
import { t } from '$i18n'
import { toHumanReadablePhone } from '$func/phone'

export function InvitedItem({
  name,
  phone,
  date,
}: {
  name?: string
  phone: string
  date: Date
}) {
  return (
    <Stack height="56px" padding="5px 15px">
      {name || phone ? (
        <Typography variant="subtitle3">
          {name || toHumanReadablePhone(phone)}
        </Typography>
      ) : (
        <Skeleton variant="text" />
      )}
      {date ? (
        <Typography variant="caption1" color="gray">
          {t('invite.invitedAt')(date)}
        </Typography>
      ) : (
        <Skeleton variant="text" />
      )}
    </Stack>
  )
}

InvitedItem.defaultProps = {
  name: '',
}
